import { WorkflowReviewRequestForm } from '@app/generated/contracts/workflow-review-request.generated';
import { WorkflowReviewSubmissionRequestForm } from '@app/generated/contracts/workflow-review-submission-request.generated';
import { createRegisteredGeneratedFormTerminology } from './registered-generated-form-terminology';
import { WORKFLOW_WORKSPACE_REVIEW_TERMINOLOGY } from './workflow-review-form.terminology';

export function createWorkflowReviewFormTerminology(
  usages: typeof WORKFLOW_WORKSPACE_REVIEW_TERMINOLOGY,
) {
  return createRegisteredGeneratedFormTerminology([
    {
      definition: WorkflowReviewRequestForm,
      fields: [{ name: 'workSummary', usage: usages.workSummary }],
    },
    {
      definition: WorkflowReviewSubmissionRequestForm,
      fields: [
        {
          name: 'outcome',
          usage: usages.outcome,
          options: [
            { value: 'approved', usage: usages.approved },
            { value: 'changes_required', usage: usages.changesRequired },
          ],
        },
        { name: 'notes', usage: usages.notes },
      ],
    },
  ]);
}
